// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Video_wrap__kZWlk","videoWrap":"Video_videoWrap__OYZPs","flex":"Video_flex__IAwN7","iframe":"Video_iframe__wWLVh"};